/**
 * AI Helper locale definitions for the language picker UI.
 *
 * Mirrors the SUPPORTED_LOCALES in ai-helper-i18n.js (backend).
 * When adding or removing locales, update both files.
 */

export interface LocaleConfig {
	code: string;
	name: string;
	flag: string;
	dateExample: string;
	numExample: string;
	group: LocaleGroup;
}

export type LocaleGroup = 'English' | 'Français' | 'Deutsch' | 'Español' | 'Português';

export const SUPPORTED_LOCALES: LocaleConfig[] = [
	// ── English variants ──────────────────────────────────────────
	{ code: 'en',    name: 'English (US)',       flag: '🇺🇸', dateExample: 'MM/DD/YYYY', numExample: '1,234.56', group: 'English'    },
	{ code: 'en-GB', name: 'English (UK)',        flag: '🇬🇧', dateExample: 'DD/MM/YYYY', numExample: '1,234.56', group: 'English'    },
	{ code: 'en-AU', name: 'English (AU)',        flag: '🇦🇺', dateExample: 'DD/MM/YYYY', numExample: '1,234.56', group: 'English'    },
	{ code: 'en-CA', name: 'English (Canada)',    flag: '🇨🇦', dateExample: 'YYYY-MM-DD', numExample: '1,234.56', group: 'English'    },

	// ── French ────────────────────────────────────────────────────
	{ code: 'fr',    name: 'Français',            flag: '🇫🇷', dateExample: 'DD/MM/YYYY', numExample: '1 234,56', group: 'Français'   },
	{ code: 'fr-CA', name: 'Français (Canada)',   flag: '🇨🇦', dateExample: 'YYYY-MM-DD', numExample: '1 234,56', group: 'Français'   },

	// ── German ────────────────────────────────────────────────────
	{ code: 'de',    name: 'Deutsch',             flag: '🇩🇪', dateExample: 'DD.MM.YYYY', numExample: '1.234,56', group: 'Deutsch'    },

	// ── Spanish ───────────────────────────────────────────────────
	{ code: 'es',    name: 'Español (España)',    flag: '🇪🇸', dateExample: 'DD/MM/YYYY', numExample: '1.234,56', group: 'Español'    },
	{ code: 'es-MX', name: 'Español (México)',    flag: '🇲🇽', dateExample: 'DD/MM/YYYY', numExample: '1,234.56', group: 'Español'    },

	// ── Portuguese ────────────────────────────────────────────────
	{ code: 'pt',    name: 'Português',           flag: '🇵🇹', dateExample: 'DD/MM/YYYY', numExample: '1.234,56', group: 'Português'  },
	{ code: 'pt-BR', name: 'Português (Brasil)',  flag: '🇧🇷', dateExample: 'DD/MM/YYYY', numExample: '1.234,56', group: 'Português'  },
];

export const LOCALE_GROUPS: LocaleGroup[] = [
	'English', 'Français', 'Deutsch', 'Español', 'Português',
];

export function getLocaleByCode(code: string): LocaleConfig | undefined {
	return SUPPORTED_LOCALES.find(l => l.code === code);
}

/** Return the 2–5 char display label for the picker button (e.g., "EN", "FR-CA"). */
export function localeLabel(code: string): string {
	return (code || 'en').toUpperCase();
}
